// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"36a20004","160":"abfb9715","208":"70ca4e44","293":"de9f399e","516":"dd554782","519":"b278eb95","917":"c3ec9579","946":"b781484e"}[chunkId] + ".chunk.js";
};